// extracted by mini-css-extract-plugin
export default {"wrap":"Counter_wrap__2nIpG","label":"Counter_label__rNtiN","digits":"Counter_digits__EugUK"};